/**
 * Generates a temporary ID for new bonds or imported bonds
 * @returns A unique temporary ID string
 */
export const generateTempId = (): string => {
  return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}; 